import React, { useState } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { Bonus } from '../services/bonusService';
import ModernBonusList from './ModernBonusList';
import ModernBonusForm from './ModernBonusForm';

const ModernBonusManagement: React.FC = () => {
  const { translate } = useTranslation();
  const [formOpen, setFormOpen] = useState(false);
  const [editingBonus, setEditingBonus] = useState<Bonus | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreateClick = () => {
    setEditingBonus(null);
    setFormOpen(true);
  };

  const handleEditClick = (bonus: Bonus) => {
    setEditingBonus(bonus);
    setFormOpen(true);
  };

  const handleFormClose = () => {
    setFormOpen(false);
    setEditingBonus(null);
  };

  const handleFormSave = async (bonus: Bonus) => {
    setFormOpen(false);
    setEditingBonus(null);
    setTimeout(() => {
      setRefreshKey((prev) => prev + 1);
    }, 500);
  };

  return (
    <div className="container mx-auto p-6" data-testid="bonus-management">
      <ModernBonusList
        refreshTrigger={refreshKey}
        onCreateClick={handleCreateClick}
        onEditClick={handleEditClick}
      />

      <ModernBonusForm
        open={formOpen}
        onClose={handleFormClose}
        onSave={handleFormSave}
        bonus={editingBonus}
      />
    </div>
  );
};

export default ModernBonusManagement;

